import React from 'react';
import { useSelector } from 'react-redux';
import Report from './Report';
import Reports from './Reports';
import ReportsMain from './ReportsMain';
import { ReportCategoryName } from '../../../constants/system-constants';

function getPageForRoute(key: string) {
    const selected = {
        'my-reports': <ReportsMain reportCategoryName={ReportCategoryName.MY_REPORTS} />,
        'my-report': <Report reportCategoryName={ReportCategoryName.MY_REPORTS} />,
        // 'audit-report': <AuditReport />,
        'transaction-report': <ReportsMain reportCategoryName={ReportCategoryName.TRANSACTIONAL} key="transactional" />,
        'transaction-reports': <Report reportCategoryName={ReportCategoryName.TRANSACTIONAL} />,
        'time-attendance-report': <ReportsMain reportCategoryName={ReportCategoryName.TIME_AND_ATTENDANCE} key="timeAndAttendance" />,
        'time-attendance-reports': <Report reportCategoryName={ReportCategoryName.TIME_AND_ATTENDANCE} />,
        'access-control-report': <ReportsMain reportCategoryName={ReportCategoryName.ACCESS_CONTROL} key="accessControl" />,
        'access-control-reports': <Report reportCategoryName={ReportCategoryName.ACCESS_CONTROL} />,
        'system-setup-report': <ReportsMain reportCategoryName={ReportCategoryName.SYSTEM_SETUP} key="systemSetup" />,
        'system-setup-reports': <Report reportCategoryName={ReportCategoryName.SYSTEM_SETUP} />,
        'emergency-safety-report': <ReportsMain reportCategoryName={ReportCategoryName.EMERGENCY_AND_SAFETY} key="emergencyAndSafety" />,
        'emergency-safety-reports': <Report reportCategoryName={ReportCategoryName.EMERGENCY_AND_SAFETY} />,
        'compliance-report': <ReportsMain reportCategoryName={ReportCategoryName.COMPLIANCE} key="compliance" />,
        'compliance-reports': <Report reportCategoryName={ReportCategoryName.COMPLIANCE} />,
        'report': <Report reportCategoryName="NONE" />,
    }[key];
    
    if (selected) {
        return selected;
    }
    return <Reports />
}

function getKeyFromPath(path: string) {
    const contentKey = 3;
    const key = path.split('/')[contentKey];
    return key;
}

const ReportsIndex = () => {
    const page = useSelector((state: any) => state.router.location.pathname);

    return getPageForRoute(getKeyFromPath(page));
}

export default ReportsIndex;
